import React from 'react'
import classnames from 'classnames/bind'
import * as graph from '@adc/sdk'
import PropTypes from 'prop-types'
import { Field } from 'redux-form'
import { CheckboxFieldReduxFormWrapper, MapPin, images } from '@adc/ui-adc'
import styles from './styles.scss'
const cx = classnames.bind(styles)

const AssetTypeFiltersContent = ({
  elmId,
  className,
  submitForms,
  shortSalesFilterEnabled,
  privateSellerFilterEnabled,
  privateSellerEnabled,
}) => (
  <section data-elm-id={elmId} className={className}>
    <div>
      <Field
        compact
        type='checkbox'
        name='bankOwned'
        elmId={`${elmId}_bank_owned`}
        onChange={submitForms}
        label={
          <MapPin
            label='REO Bank Owned'
            dotAssetType={graph.enums.AssetType.BankOwned}
            lighterShadow
          />
        }
        component={CheckboxFieldReduxFormWrapper}
      />

      <Field
        compact
        type='checkbox'
        name='foreclosure'
        elmId={`${elmId}_foreclosure`}
        onChange={submitForms}
        label={
          <MapPin
            label='Foreclosure Homes'
            dotAssetType={graph.enums.AssetType.Foreclosure}
            lighterShadow
          />
        }
        component={CheckboxFieldReduxFormWrapper}
      />

      {shortSalesFilterEnabled && (
        <Field
          compact
          type='checkbox'
          name='shortSales'
          elmId={`${elmId}_short_sales`}
          onChange={submitForms}
          label={
            <MapPin
              label='Short Sales'
              dotAssetType={graph.enums.AssetType.ShortSale}
              lighterShadow
            />
          }
          component={CheckboxFieldReduxFormWrapper}
        />
      )}
      {privateSellerFilterEnabled && (
        <Field
          compact
          type='checkbox'
          name='privateSeller'
          elmId={`${elmId}_private_seller`}
          onChange={submitForms}
          label={
            <div className={cx('private-seller-filter-container')}>
              <MapPin
                label='Private Seller'
                dotAssetType={graph.enums.AssetType.PrivateSeller}
                lighterShadow
              />
              {privateSellerEnabled && (
                <img src={images.smartsaleLogoIcon} style={{ width: 20 }} />
              )}
            </div>
          }
          component={CheckboxFieldReduxFormWrapper}
        />
      )}
    </div>
  </section>
)

AssetTypeFiltersContent.propTypes = {
  className: PropTypes.string,
  elmId: PropTypes.string.isRequired,
  submitForms: PropTypes.func.isRequired,
  shortSalesFilterEnabled: PropTypes.bool.isRequired,
  privateSellerFilterEnabled: PropTypes.bool.isRequired,
  privateSellerEnabled: PropTypes.bool.isRequired,
}

export default AssetTypeFiltersContent
